/* eslint-disable import/prefer-default-export */

/**
 * Convert values from `from_unit` to `to_unit`, no rounding is done by default.
 */
export const convertUnit = (value, fromUnit, toUnit, rounding = undefined) => {
  if (fromUnit.type !== toUnit.type) {
    // Only same types can be converted.
    throw Error(`Cannot convert from ${fromUnit.symbol} to ${toUnit.symbol}`);
  }

  if (typeof rounding === 'number') {
    // `Math.round` rounds to the nearest integer. Values need to be scaled up before the rounding then scaled down.
    const scaler = 10 ** rounding;

    return Math.round((value / fromUnit.conversion) * toUnit.conversion * scaler) / scaler;
  }

  // Return raw value
  return (value / fromUnit.conversion) * toUnit.conversion;
};
